module.exports = __webpack_public_path__ + "img/banner_img_0007.53940eb9.jpg";